skrilla.controller('createCampaignCtrl', function ($scope, searchService, modalService, cacheService, validationService) {
    $scope.validate = {}
    $scope.openToAllEligibleUsers = true;

    //duplicated from updateCampaignModal.js but this is going to be replaced with v2 soon
    $scope.bettingTabs = {
        SPORTS_SINGLES: false,
        SPORTS_SEM: false,
        RACING_SINGLES: false,
        RACING_SEM: false
    }

    $scope.apply = function(){
        if(validateForm()){
           modalService.confirm("Are you sure you'd like to create campaign?", function(){
               const tabs = Object.entries($scope.bettingTabs).filter(([key, value]) => value).map(([key, value]) => key)
                searchService.post("campaigns",
                    {name: $scope.name, description: $scope.description, openToAllEligibleUsers: $scope.openToAllEligibleUsers, bettingTabs: tabs, termsOfUse: $scope.termsOfUse},  "Success.", true
                ).then(function(response){
                    modalService.dismissAll()
                })
            })
        }
    }

    function validateForm(){
        var inputs = [
            validationService.buildFieldValidationObj("name", !validationService.isEmpty($scope.name), "Please enter a valid name"),
        ];
        return validationService.validateForm(inputs, $scope.validate)
    }

});
